export namespace TunnelSanteEventModels {
  /** Documents  */
  export enum PolicyEventType {
    Unknown = 0,
    AddComplementToPolicyEvent = 1,
    AddMiscRefundEvent = 2,
    AddRefundChequeNumbersEvent = 3,
    AgeoSubscriptionCreatedEvent = 4,
    AgeoSubscriptionFailedEvent = 5,
    AllowPaymentForTerminatedAutoPolicyEvent = 6,
    AvenantConfirmedEvent = 7,
    AvenantHandledEvent = 8,
    AvenantPaymentNotificationHandledEvent = 9,
    AvenantPaymentTransactionStartedEvent = 10,
    AvenantRequestRejectedEvent = 11,
    AvenantSavedEvent = 12,
    AvenantValidatedEvent = 13,
    BankRejectCreatedEvent = 14,
    BrokerContractSignatureTransactionCreatedEvent = 15,
    ClaimRefundCreatedFromIms506FileEvent = 16,
    CommentCreatedEvent = 17,
    ComplementDeletedEvent = 18,
    ComplementPaymentNotificationHandledEvent = 19,
    CreatedOrUpdatedSinisterWithFileEvent = 20,
    EditFragmentEvent = 21,
    GenerateFileForCustomerPaymentEvent = 22,
    GenerateFileForCustomerRefundEvent = 23,
    HandlingBrokerSubscriptionCreatedEvent = 24,
    HealthPolicyCreatedEvent = 25,
    HealthPolicyUpdatedEvent = 26,
    HealthPropositionCreatedEvent = 27,
    HealthPropositionSignatureTransactionCreatedEvent = 28,
    HealthPropositionSignedEvent = 29,
    PaymentNotificationHandledEvent = 30,
    PaymentOrderSentEvent = 31,
    PolicyActivatedEvent = 32,
    PolicyCreatedEvent = 33,
    PolicyNoticedEvent = 34,
    PolicyQuantiemeUpdatedEvent = 35,
    PolicyRenewalProposedEvent = 36,
    PolicyRenewalRejectedEvent = 37,
    PolicyRenewedEvent = 38,
    PolicySetAsCaducEvent = 39,
    PolicySetAsNulliteEvent = 40,
    PolicySuspendedEvent = 41,
    PolicyTerminatedEvent = 42,
    PolicyUpdatedPricingEvent = 43,
    PolicyUpdatedRiskEvent = 44,
    PrelevementRejectedEvent = 45,
    ReceipPaidEvent = 46,
    ReceiptsPaymentNotificationHandledEvent = 47,
    ReceiptsPendingRefundCancelledEvent = 48,
    RefundReceiptValidatedEvent = 49,
    RejectReceiptCanceled = 50,
    RemoveReceiptFeesEvent = 51,
    SaveDocumentInformationsEvent = 52,
    SetAsFinGarantieProvisoireEvent = 53,
    SinisterUpdatedFromIms508FileEvent = 54,
    PolicySmsSentEvent = 55,
    TerminationRequestCancelledEvent = 56,
    TerminationRequestUpdatedEvent = 57,
    TerminationRequestUpsertedEvent = 58,
    FileAddedToPolicyEvent = 59,
    RefundForPolicyValidatedEvent = 60,
    PolicyCommentCreatedEvent = 61,
    ComplementCreatedEvent = 62,
    HealthContractPrintedEvent = 63,
    AgencyUpdatedEvent = 64,
    HealthQuotationCreatedEvent = 65,
    PolicyBrokerSlipEvent = 66,
    AgencyApiCredentialsGeneratedEvent = 67,
    AgencyContractGeneratedEvent = 68,
    AgencyContractSignedEvent = 69,
    AgencyDeletedEvent = 70,
    AgencyInSubscriptionArchivedEvent = 71,
    AgencyUnarchivedEvent = 72,
    AgeoBrokerFileCreatedEvent = 73,
    CallBrokerEvent = 74,
    ReplyToAgencyEmailEvent = 75,
    SendEmailToAgencyEvent = 76,
    SubscriptionEditedEvent = 77,
    GenerateFileForAgencyPaymentEvent = 78,
    SubBrokerArchivedEvent = 79,
    SubBrokersGeneratedEvent = 80,
    AgencyCommentCreatedEvent = 81,
    AutomobileQuotationCreatedEvent = 82,
    PaymentErrorEvent = 83,
    HealthDirectDebitPrelevementOperationEvent = 84,
    HealthPropositionSignFailedEvent = 85,
    LostPasswordForAgencyEvent = 86,
    MainBrokerEmailUpdatedEvent = 87,
    DoublePaymentForQuotationEvent = 88,
    DoublePaymentEvent = 89,
    AgencyTransferredToEvent = 90,
    AgencyTransferredFromEvent = 91,
    PolicyTransferredEvent = 92,
    MonthlyAgencySlipRequestValidatedEvent = 93,
    MonthlyAgencySlipValidatedEvent = 94,
    MonthlyAgencySlipCreatedEvent = 95,
    MonthlyAgencySlipDeletedEvent = 96,
    HealthPolicySyncRequestedEvent = 97,
    StartReceiptTransactionEvent = 98,
    StartComplementTransactionEvent = 99,
    MonthlyInsurerSlipCreatedEvent = 100,
    MonthlyInsurerSlipValidatedEvent = 101,
    AgeoSubscriptionTechincalFailureEvent = 102,
    RopSignatureCreatedEvent = 103,
    RopQuotationSignedEvent = 104,
    RopQuotationCreatedEvent = 105,
    RopPolicyCreatedEvent = 106,
    PolicySetAsNoEffectEvent = 107,
    ActionCancelledBeforeAccountingEvent = 108,
    DoublePaymentReceiptEvent = 109,
    RopSignatureOrderCreatedEvent = 110,
    QuotationSignatureTransactionCreatedEvent = 111,
    QuotationSmsSentEvent = 112,
    PolicySignatureTransactionCreatedEvent = 113,
    AutoPolicySignedEvent = 114,
    AutoSignatureOrderCreatedEvent = 115,
    EmailAssignedToPolicy = 116,
    EmailAssignedToAgency = 117,
    HealthPolicyStatusForcedEvent = 118,
    PaymentSuccessEvent = 119,
    EmailUpdatedEvent = 120,
    EmailRepliedEvent = 121,
    SinisterFileUploadedEvent = 122,
    EmailTransferredEvent = 123,
    HealthQuotationSignedEvent = 124,
    TerminationInfoUpdatedEvent = 125,
    PolicyPrelevementEvent = 126,
    AvenantRequestSuspendedEvent = 127,
    EmailAssignedToPolicyEvent = 128,
    PoliyDocumentCreatedEvent = 129,
    EmailAssignedEvent = 130,
    HealthPolicyControlJobStatusUpdatedEvent = 131,
    AgeoContractReferenceUpdatedEvent = 132,
    PolicyNotifiedForDocumentEvent = 133,
    NotifyForDocumentPolicyEvent = 134,
  }

  export enum AgencyEventType {
    AgencyUpdatedEvent = 64,
    AgencyApiCredentialsGeneratedEvent = 67,
    AgencyContractGeneratedEvent = 68,
    AgencyContractSignedEvent = 69,
    AgencyDeletedEvent = 70,
    AgencyInSubscriptionArchivedEvent = 71,
    AgencyUnarchivedEvent = 72,
    AgeoBrokerFileCreatedEvent = 73,
    CallBrokerEvent = 74,
    ReplyToAgencyEmailEvent = 75,
    SendEmailToAgencyEvent = 76,
    SubscriptionEditedEvent = 77,
    GenerateFileForAgencyPaymentEvent = 78,
    SubBrokerArchivedEvent = 79,
    SubBrokersGeneratedEvent = 80,
    AgencyCommentCreatedEvent = 81,
    LostPasswordForAgencyEvent = 86,
    MainBrokerEmailUpdatedEvent = 87,
    AgencyTransferredToEvent = 90,
    AgencyTransferredFromEvent = 91,
    MonthlyAgencySlipValidatedEvent = 94,
    MonthlyAgencySlipCreatedEvent = 95,
    MonthlyAgencySlipDeletedEvent = 96,
    HandlingBrokerSubscriptionCreatedEvent = 24,
    EmailAssignedToAgency = 117,
  }
}
